import { render, staticRenderFns } from "./merchantRegisterCode.vue?vue&type=template&id=fb2be926&scoped=true&"
import script from "./merchantRegisterCode.vue?vue&type=script&lang=js&"
export * from "./merchantRegisterCode.vue?vue&type=script&lang=js&"
import style0 from "./merchantRegisterCode.vue?vue&type=style&index=0&lang=css&"
import style1 from "./merchantRegisterCode.vue?vue&type=style&index=1&id=fb2be926&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb2be926",
  null
  
)

export default component.exports